import { useTranslation } from 'react-i18next';
import { Label, LabelType } from './Label.component';
import { ColorType } from './shared/Colors.g';
import { SubmitLoading } from './Skeleton/SubmitLoading.component';

interface DashboardLoadingProps {
  className?: string;
}

export const DashboardLoading = ({
  className = 'flex flex-col items-center gap-4 inset-2/4 fixed',
}: DashboardLoadingProps) => {
  const { t } = useTranslation();

  return (
    <div className={className}>
      <SubmitLoading />
      <Label
        text={t('loading_dashboard')}
        type={LabelType.LABEL_S_MEDIUM}
        color={ColorType.GREY4}
        className='w-max'
      />
    </div>
  );
};
